import React from "react";
import Article from "../Article";

const Blog = () => {
  return <Article type="Blog" title="Bài viết"></Article>;
};

export default Blog;
